import React, { forwardRef, useImperativeHandle } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { getCategoryAdSlotConfigs } from '../../../../../utils/getCategoryAdSlotConfigs'

const StyledAdv = styled.div(({ theme: { spaces } }) => ({
  width: '100%',
  margin: `${spaces.default}px auto`,
}))

const CategoryAdv = forwardRef(({
  category, flyerId, clientType, country,
}, ref) => {
  const advData = getCategoryAdSlotConfigs(category, flyerId, clientType)(country)

  useImperativeHandle(ref, () => ({
    getAdvData() {
      return advData
    },
  }))

  if (!advData || !Object.keys(advData).length) return null

  return <StyledAdv id={advData.domNodeId} />
})

CategoryAdv.propTypes = {
  category: PropTypes.string,
  flyerId: PropTypes.string,
  clientType: PropTypes.oneOf(['app', 'web']),
  country: PropTypes.string,
}

CategoryAdv.defaultProps = {
  category: '',
  flyerId: '',
  clientType: 'web',
  country: '',
}

export default React.memo(CategoryAdv)
